document.addEventListener("DOMContentLoaded", function () {
  var extras = document.getElementById("choice_2_3_1");
  var forms = document.getElementsByClassName("reservation_form");

  if (forms && extras) {
    extras.setAttribute("disabled", "");

    function formDataFunction(element) {
      jQuery(function ($) {
        var $this = $(element);
        var id = $this.val();
        var beforeDelimiter = id;

        let delimiterIndex = id.indexOf(",");
        if (delimiterIndex !== -1) {
          beforeDelimiter = id.slice(0, delimiterIndex);
          console.log(beforeDelimiter);
        }

        var selectedOption = $("#input_2_21 option:selected").text();
        var typeResult = "";
        var retraiteType = document.getElementById("input_2_24");
        var event = new Event("change", {
          bubbles: true,
          cancelable: true,
        });

        if (selectedOption.includes("Weekend")) {
          typeResult = "weekend";
        } else if (selectedOption.includes("Midweek")) {
          typeResult = "midweek";
        } else {
          typeResult = "weekend";
        }

        // Change "set_retraite_type" to the parameter key of the target field
        $("#input_2_24").val(typeResult);
        retraiteType.dispatchEvent(event);
        // console.log($this.val());
        $("#input_2_8").val("");
        $.ajax({
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          dataType: "json",
          data: {
            action: "human_check_stock",
            id: beforeDelimiter,
          },
          beforeSend: function () {
            console.log("loading data...");
          },
          success: function (res) {
            console.log(res);

            var reserved_spaces = res.reserved_spaces;

            var total_rooms = res.total_rooms;

            // var single = res.total_private_stock;
            // var shared = res.total_shared_stock;

            var available_single = res.available_private;
            var available_shared = res.available_shared;

            var open_spots = res.open_spots;

            var checkboxDiv = document.getElementById("input_2_3");
            var checkbox = document.getElementById("choice_2_3_1");
            var extras = document.getElementById("input_2_8");
            var checkboxWrapper = document.getElementById("field_2_3");
            var legendElement = checkboxWrapper.querySelector("legend");

            // console.log(total_spaces);

            if (available_single > 1 && available_shared > 1) {
              checkbox.removeAttribute("disabled");
              checkboxDiv.style.opacity = "1";
              checkboxWrapper.style.opacity = "1";
              legendElement.textContent = "Optioneel: eenpersoonskamer";

              extras.removeAttribute("disabled", "");
              extras.style.opacity = "1";

              //meerdere personen input wel beschikbaar (maximaal shared - 1)
              extras.setAttribute("data-max", parseInt(open_spots) - 1);
              extras.addEventListener("change", function () {
                var max = parseInt(this.getAttribute("data-max"));

                if (this.value > max) {
                  if (max == 1) {
                    alert(`Fout: Maximaal ${max} extra plek beschikbaar`);
                  } else if (max >= 2) {
                    alert(`Fout: Maximaal ${max} extra plekken beschikbaar`);
                  }
                  this.value = max;
                }
              });

              console.log(
                "The available spot for private and shared rooms are both larger than 1."
              );
            } else if (available_single == 0 && available_shared == 1) {
              checkbox.setAttribute("disabled", "");
              checkboxWrapper.style.opacity = "0.5";
              extras.setAttribute("disabled", "");
              extras.style.opacity = "0.5";
              legendElement.textContent =
                "Optioneel (niet meer beschikbaar voor deze datum)";

              console.log(
                "All private rooms have been booked, only ONE shared available."
              );
            } else if (available_single == 0 && available_shared >= 1) {
              checkbox.setAttribute("disabled", "");
              checkboxWrapper.style.opacity = "0.5";
              legendElement.textContent =
                "Optioneel (niet meer beschikbaar voor deze datum)";

              //meerdere personen input wel beschikbaar (maximaal shared - 1)
              extras.setAttribute("data-max", parseInt(open_spots) - 1);
              extras.addEventListener("change", function () {
                var max = parseInt(this.getAttribute("data-max"));

                if (this.value > max) {
                  if (max == 1) {
                    alert(`Fout: Maximaal ${max} extra plek beschikbaar`);
                  } else if (max >= 2) {
                    alert(`Fout: Maximaal ${max} extra plekken beschikbaar`);
                  }
                  this.value = max;
                }
              });
              console.log(
                "All private rooms have been booked, only shared available."
              );
            } else if (available_single == 1 && available_shared == 1) {
              extras.setAttribute("disabled", "");
              extras.style.opacity = "0.5";

              checkbox.removeAttribute("disabled", "");
              checkboxDiv.style.opacity = "1";

              alert("Laatste vrije plek in deze Retraite.");

              console.log("There is only one spot left in this Retraite.");
            } else {
              checkbox.removeAttribute("disabled");
              checkboxWrapper.style.opacity = "1";
              legendElement.textContent = "Optioneel: eenpersoonskamer";

              extras.removeAttribute("disabled", "");
              extras.style.opacity = "1";
            }
          },
        });
      });
    }

    jQuery(function ($) {
      formDataFunction("#input_2_21");
    });

    jQuery(function ($) {
      $("#input_2_21").on("change", function (e) {
        formDataFunction("#input_2_21");

        //set midweek or weekend logic
      });
    });

    if (forms.length >= 1) {
      // Get the checkbox ID from the URL parameter
      const urlParams = new URLSearchParams(window.location.search);
      const checkboxId = urlParams.get("option");
      const reloadData = new Event("change", {
        cancelable: true,
        bubbles: true,
      });

      document.getElementById("input_2_21").dispatchEvent(reloadData);

      // console.log(checkboxId);

      // Check the corresponding option if the ID is provided in the URL
      if (checkboxId) {
        for (let i = 0; i < forms.length; i++) {
          const options = forms[i].querySelectorAll("option");
          for (let j = 0; j < options.length; j++) {
            if (options[j].value === checkboxId) {
              options[j].selected = "selected";
              // console.log('Option has been selected');
              break;
            }
          }
        }
      }
      // console.log('Exists');
    } else {
      // console.log('Does not exist');
    }
  }
});
